import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../redux/slices/OfficeOnboardingSlice";
import { AppDispatch, RootState } from "../../redux/store";
import { logger } from "../../utils/logger";
import { getOffice } from "../../redux/slices/OfficeSlice";
import { searchServiceData } from "../../redux/slices/ServiceSlice";
import { ServiceOwner } from "../../models/service.model";

interface OnboardingStepHeaderProps {
  currentStep: number;
  totalSteps?: number;
}

const OnboardingStepHeader: React.FC<OnboardingStepHeaderProps> = ({ currentStep, totalSteps = 5 }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentOffice } = useSelector((state: RootState) => state.office);
  const log = logger.getLogger("OnboardingStep5");

  const handleClose = async () => {
    // Step 5 already handles completing onboarding in its useEffect
    // Just close the modal directly to avoid showing loader
    dispatch(closeModal());
    if (currentStep === 5) {
      const officeId = currentOffice?.officeId;
      if (!officeId) {
        log.error("Office ID not found in currentOffice");
        return;
      }
      await dispatch(getOffice({ officeId })).unwrap();
      dispatch(
        searchServiceData({
          officeId: officeId,
          page: 0,
          sort: "name",
          size: 200,
          enabledOnly: true,
          serviceOwner: ServiceOwner.Office,
        })
      );
    }
  };

  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="sticky top-0 bg-white z-10 border-b border-gray-200">
      <div className="flex items-center justify-between p-6">
        {/* Progress Info */}
        <div className="flex-1">
          <div className="flex justify-between items-center">
            <p className="text-sm leading-[20px] tracking-[-0.15px] text-dn-slate">
              Step {currentStep} of {totalSteps}
            </p>
            {/* Close Button */}
            <button
              onClick={handleClose}
              className="ml-6 text-gray-400 hover:text-gray-600 text-3xl font-light w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              aria-label="Close modal"
            >
              ×
            </button>
          </div>

          <div className="w-full mt-4 bg-[#030213]/20 rounded-full h-2">
            <div className="bg-[#030213] h-2 rounded-full transition-all duration-300" style={{ width: `${progressPercentage}%` }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingStepHeader;
